/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';

export function mobileNav() {
  // var hamburger = document.querySelector('.hamburger');
  // var body = document.querySelector('body');

  // document.addEventListener('click', function () {
  //   hamburger.classList.toggle('is-active');
  //   if (body.classList.contains('navOpen')) {
  //     body.classList.remove('navOpen');
  //   } else {
  //     body.classList.add('navOpen');
  //   }
  // });

  $(document).on('click tap', '.hamburger', function() {
    if ($(this).hasClass('is-active')) {
      $(this).removeClass('is-active');
      $('body').removeClass('navOpen');
    } else {
      $(this).addClass('is-active');
      $('body').addClass('navOpen');
    }
  });


  // Nav Images
  $( ".mainNav__li" ).mouseenter(function() {
    var navImage = $(this).attr('data-nav-id');
    // alert(navImage);
    $('.navImage').removeClass('active');
    $('.navImage--' + navImage).addClass('active');
  });
}
